import { Cache } from '@aws-amplify/cache';
import { Location } from "history";
import { MenuUrlEnum } from 'src/components/common/side-menu/MenuUrlEnum';
import { SessionStorageEnum } from '../enum/SessionStorageEnum';

export const SessionInterceptorRejected = (location: Location, redirect: (path: string) => void) => (error: any): any => {
  if (location.pathname !== MenuUrlEnum.Login && error.response && (error.response.status === 401 || error.response.status === 403)) {
    Cache.removeItem("jwt")
    sessionStorage.removeItem(SessionStorageEnum.session)
    redirect(MenuUrlEnum.Login)
  }

  return Promise.reject(error)
};